function getCookie (name) {
    var _a;
    return ((_a = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')) === null || _a === void 0 ? void 0 : _a.pop()) || '';
}

export { getCookie as default };
//# sourceMappingURL=getCookie.js.map
